<template>
	<div class="fill-height pointer-events-none">
		<div v-if="emptyDesign" class="empty-button">No button designed yet</div>
		<div v-else class="text-overflow-ellipsis">
			<span v-if="icon" class="pr-2">{{ icon }}</span
			><span v-if="text" :style="textStyle">{{ text }}</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'NativeElementTreeBlockButton',
	components: {},
	props: {
		element: { type: Object },
	},
	computed: {
		data() {
			return this.element.data;
		},
		icon() {
			return this.data.icon && this.data.icon.value;
		},
		text() {
			return this.data.text && this.data.text.value;
		},
		emptyDesign() {
			return !this.icon && !this.text;
		},
		textStyle() {
			const defaults = {
				color: 'black',
				fontSize: '14px',
			};
			if (this.data.text) {
				const extractStyleKeysFromObject = ({ color, fontSize }) => ({ color, fontSize });
				return { ...defaults, ...extractStyleKeysFromObject(this.data.text) };
			}
			return defaults;
		},
	},
};
</script>
<style scoped>
.empty-button {
	size: 12px;
	color: #0000004c;
}
</style>
